export class PickingDiffFilter {
  public positionName: string = ''
}
